export default __webpack_public_path__ + "static/media/Peach waves3.45cf67ac.jpg";